import { render, staticRenderFns } from "./itemPanelData.vue?vue&type=template&id=b7a33af6&scoped=true&"
import script from "./itemPanelData.vue?vue&type=script&lang=js&"
export * from "./itemPanelData.vue?vue&type=script&lang=js&"
import style0 from "./itemPanelData.vue?vue&type=style&index=0&id=b7a33af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a33af6",
  null
  
)

export default component.exports